import { SimpleTabsItemView, SimpleTabsListView } from './views';
import withDropdown from './enhancers/withDropdown';

/**
 * Tab View Group handling overflow by showing a `More` dropdown button
 * These tabs are not production ready, they still require context to function
 */
export const [DropdownTabsListView, DropdownTabsItemView] = withDropdown([
  SimpleTabsListView,
  SimpleTabsItemView,
]);
